if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.querySelectorAll('.product-media-modal__arrow').forEach((arrow) => {
          // Keep ModalDialog's mouse pointerup from treating an arrow press as a close
          arrow.addEventListener('pointerup', (event) => event.stopPropagation());
          arrow.addEventListener('click', () => {
            const container = this.querySelector('[role="document"]');
            container.scrollBy({ left: Number(arrow.dataset.direction) * container.clientWidth, behavior: 'smooth' });
          });
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        if (getComputedStyle(container).scrollSnapType.startsWith('x')) {
          container.scrollLeft += activeMedia.getBoundingClientRect().left - container.getBoundingClientRect().left;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
